<template>
  <div class="container">
    <div class="wrap box-con">
      <div class="order-info">
        <div class=" z-flex z-flex-between">
          <div class="order-num z-flex"><i class="el-icon-picture-outline"></i>返修图片</div>
        </div>
        <div class="tips">请认真填写返修备注，修图老师修图完成后替换对应图片重新上传</div>
      </div>
      <div class="imgs-con">
        <div class="hd z-flex z-flex-between">
          <div class="btn-group">
            <el-button @click="cancel">放弃返修</el-button>
            <el-button type="primary" :loading="formLoading" @click="formsubmit">提交返修申请</el-button>
          </div>
        </div>
        <div class="bd">
          <div class="item z-flex z-flex-between" v-for="(item,index) in list" :key="index">
            <div class="item-l">
              <el-image class="img" fit="cover" :src="item.img + `?x-oss-process=image/resize,m_lfit,w_600,h_360&x-zos-process=image/resize,m_lfit,w_600,h_360`" :preview-src-list="[item.img]"></el-image>
              <div class="name">{{item.name}}</div>
            </div>
            <div class="item-r">
              <el-input
                type="textarea"
                :rows="5"
                resize="none"
                maxlength="500"
                show-word-limit
                placeholder="请输入修图需求信息"
                v-model="item.remark">
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      formLoading: false,
      userpsId: '',
      orderNum: '',
      md5: '',
      list:[],
    };
  },
  computed: {
    
  },
  mounted() {
    this.userpsId = this.$route.params.userpsId;
    this.orderNum = this.$route.params.orderNum;
    this.md5 = this.$route.query.md5;
    this.$axios.api.request({
      url: "/api/qtclub/userps/myPsRepair",
      method: "POST",
      data: {
        unique_no: this.orderNum,
        md5: this.md5,
      }
    }, (res) => {
      this.list = res.data.list;
    })
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    cancel(){
      this.$router.push({
        path:'/my/psCheckOrder',
        query: {userpsId: this.userpsId}
      })
    },
    formsubmit(){
      let params = {
        unique_no: this.orderNum,
        images: []
      };
      for (let i=0; i<this.list.length; i++) {
        if (this.list[i].remark == '') {
          return this.$message.error("请输入修图需求信息")
        }
        params.images.push({img: this.list[i].img, remark: this.list[i].remark});
      }
      this.formLoading = true;
      this.$axios.api.request({
        url: "/api/qtclub/userps/myPsRepairSubmit",
        method: "POST",
        data: params
      }, (res) => {
        this.formLoading = false;
        if (res.code == 200) {
          this.$message.success("提交成功");
          setTimeout(() => {
            this.cancel();
          }, '600')
        } else {
          this.$message.error(res.msg);
        }
        console.log(res)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.box-con{
  padding: 20px 40px;
}
.order-info{
  color: #999;
  font-size: 15px;
  .order-num{
    font-size: 22px;
    color: #333;
    i{
      margin-right: 6px;
      font-size: 25px;
    }
  }
  .title{
    margin-top: 15px;
  }
  .tips{
    margin-top: 20px;
  }
}

.imgs-con{
  border-top: $borderDashed;
  padding-top: 20px;
  margin-top: 20px;
  .hd{
    font-size: 14px;
    color: #999;
    margin-bottom: 20px;
  }
  .bd{
    .item{
      margin-bottom: 20px;
       .item-l{
        width: 300px;
        height:180px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        .img{
          width:100%;
          height:100%;
        }
        .name{
          width: 100%;
          position:absolute;
          left:0;
          bottom: 0;
          color: #fff;
          text-shadow: 0 0 10px rgba(0,0,0,.35);
          font-size: 14px;
          padding:5px 10px;
          box-sizing: border-box;
          @extend %textOverflow;
        }
       }   
       .item-r{
        flex: 1;
        height: 180px;
        margin-left: 20px;
        ::v-deep .el-textarea{
          height: 100%;
          textarea{
            height: 100%;
          }
        }
       }  
    }
  }
}

</style>
